import { get } from 'lodash';

const root = state => get(state, 'UtilitiesState.printBarcode');

export const getItemListData = state => get(root(state), 'itemListData', []);
export const getLoading = state => get(root(state), 'loading', false);
export const getPrintLoading = state => get(root(state), 'printLoading', false);
export const getPrintError = state => get(root(state), 'printError', null);
export const getPrintData = state => get(root(state), 'printData', false);
export const getItemListingError = state =>
  get(root(state), 'itemListingError', null);



// WEBPACK FOOTER //
// ./src/pages/utilities/state/printBarcodes/selectors.js